export const switchTheme = {
    slots: {
        base: 'cursor-pointer',
    },
}
